








































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Providers
import PromotionsProvider from "@/components/app/admin/catalogue/promotions/promotionsProvider.vue";

// Types
import { IFilter, ISorter } from "@/models/tables";
import { IPromotion } from "@/models/promotions";

@Component({
  components: {
    PromotionsProvider,
    "promotion-list-item": () =>
      import(
        "@/components/app/admin/catalogue/promotions/promotionListItem.vue"
      )
  }
})
export default class PromotionsListing extends Vue {
  // Refs
  public declare $refs: {
    promotionsProvider: PromotionsProvider;
  };

  // Props

  @Prop({ default: () => () => ({}) })
  public routeFilters!: (
    vm?: PromotionsListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: () => ({}) })
  public parentFilters!: Record<string, string | number | boolean>;

  @Prop({ default: () => () => [] })
  public availableFilters!: (vm?: PromotionsListing) => IFilter[];

  @Prop({ default: () => () => [] })
  public availableSorters!: (vm?: PromotionsListing) => ISorter[];

  // Computed

  public get promotionManualFilters() {
    return {
      ...this.parentFilters,
      ...this.routeFilters(this)
    };
  }

  public get promotionAvailableFilters() {
    return this.availableFilters(this);
  }

  public get promotionAvailableSorters() {
    return this.availableSorters(this);
  }

  // Methods

  @Watch("parentFilters", { deep: true })
  public onParentFiltersChange() {
    this.$refs.promotionsProvider.reloadData();
  }

  public getPromotionType(promotion: IPromotion) {
    if (promotion.global) return this.$t("_.all_products");

    return promotion.constant_discount
      ? this.$t("_.selected_products")
      : this.$t("_.individual_promotion_per_product");
  }
}
